"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyAddProjectV1ProjectsAddPostTargetAudience = void 0;
exports.BodyAddProjectV1ProjectsAddPostTargetAudience = {
    Children: "children",
    YoungAdult: "young adult",
    Adult: "adult",
    AllAges: "all ages",
};
